<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="200px">
      <el-form-item label="銀行卡號：" prop="cardNo">
        <el-input
          v-model="form.cardNo"
          maxlength="20"
          @blur="addClass"
        ></el-input>
      </el-form-item>
      <el-form-item label="持卡人姓名：" prop="name">
        <el-input v-model="form.name" maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="證件：" required>
        <div class="flexa">
          <el-input
            style="width: 80px; margin-right: 20px"
            value="身份證"
            disabled
          ></el-input>
          <el-form-item prop="doc">
            <el-input
              style="width: 290px"
              v-model="form.doc"
              maxlength="24"
            ></el-input
          ></el-form-item>
        </div>
      </el-form-item>
      <el-form-item label="銀行預留手機號：" prop="mobile">
        <el-input v-model="form.mobile" maxlength="11"></el-input>
      </el-form-item>
      <el-form-item label="手機驗證碼：" prop="captcha">
        <el-input
          style="width: 230px"
          v-model="form.captcha"
          maxlength="6"
        ></el-input>
        <span
          class="link"
          style="margin-left: 16px; color: #09f"
          v-if="!isCounting"
          @click="signApply"
          >獲取驗證碼</span
        >
        <span
          v-if="$i18n.locale !== 'en' && isCounting"
          style="margin-left: 16px; color: #999"
          >({{ count }}s)重新获取短信</span
        >
      </el-form-item>
      <!-- <div class="tips">
        開通快捷支付，下次可憑全球付支付密碼和短信驗證碼快速付款
      </div> -->
      <el-form-item>
        <div class="flexa" style="margin-top: 40px">
          <el-button type="primary" style="width: 120px" @click="register"
            >下一步</el-button
          >
          <div class="linkH" @click="toBankList">選擇其他支付方式</div>
        </div>
        <span class="linkH" style="margin-top: 20px" @click="toFastPayRules">
          快捷支付服務和相關協定
        </span>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { aPost2 } from "@/utils/request";
import api from "@/utils/api";
import { Message } from "element-ui";
import { validateMixins } from "@/views/mixins/validate.js";
export default {
  mixins: [validateMixins],
  data() {
    return {
      form: {
        cardNo: "",
        name: "",
        doc: "",
        mobile: "",
        captcha: ""
        // cardNo: "6217000010084155038",
        // name: "罗淳雅",
        // doc: "431381198109106573",
        // mobile: "15012345678",
        // captcha: ""
      },
      imageList: [
        {
          id: "ABC",
          imgUrl: require(`@/assets/images/bank/logo/103.png`)
        },
        { id: "BOC", imgUrl: require("@/assets/images/bank/logo/104.png") },
        { id: "CCB", imgUrl: require("@/assets/images/bank/logo/105.png") },
        { id: "CEB", imgUrl: require("@/assets/images/bank/logo/303.png") },
        { id: "CIB", imgUrl: require("@/assets/images/bank/logo/309.png") },
        { id: "CITIC", imgUrl: require("@/assets/images/bank/logo/302.png") },
        { id: "CMB", imgUrl: require("@/assets/images/bank/logo/308.png") },
        { id: "CMBC", imgUrl: require("@/assets/images/bank/logo/305.png") },
        { id: "COMM", imgUrl: require("@/assets/images/bank/logo/301.png") },
        { id: "GDB", imgUrl: require("@/assets/images/bank/logo/306.png") },
        { id: "HXB", imgUrl: require("@/assets/images/bank/logo/304.png") },
        { id: "ICBC", imgUrl: require("@/assets/images/bank/logo/102.png") },
        { id: "PSBC", imgUrl: require("@/assets/images/bank/logo/403.png") },
        { id: "SPAB", imgUrl: require("@/assets/images/bank/logo/307.png") },
        { id: "SPDB", imgUrl: require("@/assets/images/bank/logo/310.png") },
        {
          id: "SHB",
          imgUrl: require("@/assets/images/bank/logo/SHB.png")
        },
        {
          id: "QDCCB",
          imgUrl: require("@/assets/images/bank/logo/QDCCB.png")
        }
      ],
      rules: {
        cardNo: [{ required: true, message: "請輸入卡號", trigger: "blur" }],
        name: [{ required: true, message: "請輸入姓名", trigger: "blur" }],
        doc: [{ required: true, message: "請輸入證件號", trigger: "blur" }],
        mobile: [{ required: true, message: "請輸入手機號", trigger: "blur" }],
        captcha: [{ required: true, message: "請輸入驗證碼", trigger: "blur" }]
      },
      count: 60,
      isCounting: false,
      bankInfo: {}
    };
  },
  mounted() {
    this.form.mobile =
      JSON.parse(sessionStorage.getItem("params")).apply_mob_no || "";
  },
  methods: {
    toFastPayRules() {
      window.open("https://www.globalcash.cn/quickPayServiceAgreement.html");
    },
    toBankList() {
      this.$router.go(-1);
      // this.$router.replace({
      //   path: "/bankList",
      //   query: { order_no: this.$route.query.order_no },
      // });
    },
    /**
     * 获取验证码
     */
    async signApply() {
      const params = {
        card_no: this.form.cardNo.replace(/\s*/g, ""),
        cert_type: "00",
        cert_id: this.form.doc,
        name: this.form.name,
        mob_no: this.form.mobile
      };
      try {
        const res = await aPost2(api.signApply, params);
        if (!res) return;
        const data = res.data;
        if (data.errCode === "99999") {
          this.startCounting();
        } else {
          this.isCounting = false;
          this.form.captcha = "";
          Message({
            message: data.errMsg || "ERROR",
            type: "error",
            duration: 2 * 1000
          });
        }
      } catch (error) {
        this.isCounting = false;
        this.form.captcha = "";
        Message({
          message: error.errMsg || "ERROR",
          type: "error",
          duration: 2 * 1000
        });
      }
    },
    //修改卡号样式,每4位加空格
    addClass() {
      this.form.cardNo = this.form.cardNo
        .replace(/\s/g, "")
        .replace(/(.{4})/g, "$1 ");
      // 查询卡所属银行
      this.queryCardBin();
    },
    async queryCardBin() {
      const params = {
        card_no: this.form.cardNo.replace(/\s*/g, "")
      };
      try {
        const res = await aPost2(api.queryCardBin, params);
        if (!res) return;
        const data = res.data;
        if (data.errCode === "99999") {
          this.bankInfo = Object.assign({}, data.retData, {
            card_no: this.form.cardNo.replace(/\s*/g, "")
          });
          this.$emit("getBank", this.bankInfo);
          // console.log("bankInfo", this.bankInfo);
        }
      } catch (error) {}
    },

    register() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const res = await aPost2(api.signApplyConfirm, {
              verify_code: this.form.captcha
            });
            if (!res) return;
            const data = res.data;
            if (data.errCode === "99999") {
              // this.startCounting();
              this.$router.push({
                name: "fastPay",
                params: { bankInfo: this.bankInfo }
              });
            } else {
              Message({
                message: data.errMsg || "ERROR",
                type: "error",
                duration: 2 * 1000
              });
            }
          } catch (error) {
            Message({
              message: error.errMsg || "ERROR",
              type: "error",
              duration: 2 * 1000
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-form {
  .el-input {
    width: 360px;
  }
  .link {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    width: 130px;
    height: 40px;
    text-decoration: none;
    color: #2272c8 !important;
  }
  .tips {
    margin-left: 182px;
    color: #999;
  }
  .linkH {
    font-size: 12px;
    color: #2272c8;
    cursor: pointer;
    margin-left: 4px;
  }
}
</style>
